import axios from 'axios';
import Vue from 'vue';
import router from '@/router';
import { Route } from 'vue-router';
import config from '@/config/config';
import verify from '@bluedot-tech/vue-ui/es/utils/verify';
const wx = require('weixin-js-sdk');
import { Toast } from 'vant';

declare module 'vue/types/vue' {
	interface Vue {
		$route: Route;
	}
}

export default Vue.extend({
	data() {
		return {
			emailReg: /^([0-9A-Za-z\-_\.]+)@([0-9A-Za-z\-_\.]+\.[a-z]{2,3}(\.[a-z]{2})?)$/,
			actions: [
				{ name: '语音咨询', url: `tel:+864008101315` },
				{ name: '表单咨询', url: `https://go.schneider-electric.cn/zh/work/support/customer-care/contact-sales.jsp` }
			]
		};
	},
	created() {},
	mounted() {
		let html = document.getElementsByTagName('html')[0];
		let page = document.getElementsByTagName('body')[0];
		setTimeout(() => {
			html.scrollTop = 0;
			page.scrollTop = 0;
		}, 0);
	},
	beforeCreate() {},
	beforeDestroy() {},
	methods: {
		closeShare() {
			wx.ready(function () {
				// wx.showOptionMenu();
				wx.hideMenuItems({
					menuList: [
						'menuItem:share:appMessage', // 分享给朋友
						'menuItem:share:timeline', // 分享到朋友圈
						'menuItem:share:qq', // 分享到QQ
						'menuItem:share:weiboApp', // 分享到Weibo
						'menuItem:share:facebook', // 分享到Facebook
						'menuItem:share:QZone', // 分享到QQ空间
						'menuItem:copyUrl', // 复制链接
						'menuItem:exposeArticle',
						'menuItem:favorite',
						'menuItem:openWithQQBrowser',
						'menuItem:openWithSafari',
						'menuItem:readMode',
						'menuItem:share:email'
					]
				});
			});
		},
		initShare(data = {}) {
			// 分享路径为首页
			// const _url = window.location.href.split('?')[0];
			const _url = window.location.href;

			// let _url = `${window.location.origin}${process.env.BASE_URL}`;
			// console.log(`${window.location.origin}${process.env.BASE_URL}`);

			const prepareShareData = (data: any) => {
				if (Object.keys(data).length === 0) {
					return {
						title: '活动微站' || window.document.title, // 标题
						desc: `2024施耐德电气关键电源业务卡车巡展` || window.document.title || '', // 简介
						link: `${_url}`, // 如果页面链接有其他参数需要自己拼接。
						imgUrl: 'http://schneider-wechat.oss-cn-beijing.aliyuncs.com/uploads/20220815/62f9f1e18f863.png'
					};
				}
				return data;
			};

			const cleanLink = (link: any) => {
				return link
					.replace(/\?form=space/g, '')
					.replace(/\?form=share/g, '')
					.replace(/\&form=space/g, '')
					.replace(/\&form=share/g, '')
					.replace(/\/\&/g, '/?');
			};

			const setupShareOptions = (shareData: any) => {
				const prefix = shareData.link.includes('?') ? '&' : '?';
				const timelineLink = `${shareData.link}${prefix}form=space`;
				const messageLink = `${shareData.link}${prefix}form=share`;

				const shareOptions = {
					title: shareData.title,
					desc: shareData.desc,
					imgUrl: shareData.imgUrl
				};

				// 分享到朋友圈（旧）
				wx.onMenuShareTimeline({
					...shareOptions,
					link: timelineLink,
					success: () => {}
				});

				// 分享到朋友圈（新）
				wx.updateTimelineShareData({
					...shareOptions,
					link: timelineLink,
					success: () => {}
				});

				// 分享给朋友(旧)
				wx.onMenuShareAppMessage({
					...shareOptions,
					link: messageLink,
					success: () => {}
				});

				// 分享给朋友(新)
				wx.updateAppMessageShareData({
					...shareOptions,
					link: messageLink,
					success: () => {}
				});
			};

			let shareData = prepareShareData(data);
			shareData.link = cleanLink(shareData.link);
			// console.log('shareData ====> ', shareData);

			wx.ready(() => {
				setupShareOptions(shareData);
			});
		},
		pageScroll(num: any) {
			let html = document.getElementsByTagName('html')[0];
			let page = document.getElementsByTagName('body')[0];
			setTimeout(() => {
				html.scrollTop = num;
				page.scrollTop = num;
			}, 0);
		},
		bodyOpen() {
			let body = document.getElementsByTagName('body')[0];
			body.style.overflow = '';
		},
		bodyClose() {
			let body = document.getElementsByTagName('body')[0];
			body.style.overflow = 'hidden';
		},
		getTime(nS: any, type = 0) {
			if (!nS || nS == undefined) return '';
			// let date = new Date(parseInt(nS) * 1000);

			// let dateVal = nS.replace('.000000Z', '');
			let dateVal = nS;
			let date = new Date(dateVal);

			if (nS.length == 10) date = new Date(parseInt(nS) * 1000);

			let Y = date.getFullYear(); //年
			let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1; //月
			let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate(); //日

			let H = date.getHours() < 10 ? '0' + date.getHours() : date.getHours(); //时
			let Mi = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(); //分
			let S = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds(); //秒

			if (type == 0) {
				return `${Y}-${M}-${D}`;
			} else if (type == 1) {
				return `${H}:${Mi}:${S}`;
			} else if (type == 2) {
				return `${Y}.${M}.${D} ${H}:${Mi}:${S}`;
			} else if (type == 3) {
				return `${Y}.${M}.${D} ${H}:${Mi}`;
			}
		},
		ifIos() {
			let ran = navigator.userAgent;
			let isIOS = !!ran.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

			// alert(isIOS ? `是苹果手机` : `非苹果手机`);

			return isIOS;
		},
		$highlightTitle(title: any, highlight: any) {
			function escapeRegExp(string: any) {
				return String(string).replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
			}

			let html = '';

			if (highlight && title) {
				// 创建一个不区分大小写的正则表达式
				const reg = new RegExp(escapeRegExp(highlight), 'gi'); // "g" 表示全局搜索，"i" 表示忽略大小写
				html = title.replace(
					reg,
					`<label style="color: #3DCD58;">$&</label>` // 使用 $& 插入匹配到的关键词
				);
			} else {
				html = title;
			}
			return `${html}`;
		},
		survey() {
			Toast('敬请期待');
		},
		goHome() {
			router.push('/');
		},
		backPage() {
			router.go(-1);
		}
	}
});
